// extracted by mini-css-extract-plugin
module.exports = {"imgBlank":"_2rnWoLddX0StI5J3Rfd1_7","downloadBtnWrapper":"_1dBLk95XohyKbNwW6eoz2n"};